export class CollectionPointListDeactivateCollectionPointsInput {
  collectionPoints: number[];

  constructor(collectionPoints: number[]) {
    this.collectionPoints = collectionPoints;
  }
}
